export default __webpack_public_path__ + "static/Flooding-63a85c22b9dea643df13409ed102f353.jpeg";